import type { ElectricityHeatSteamLocation } from './electHeatSteamTypes';

import { createSelectorCreator, lruMemoize } from 'reselect';
import { isEqual } from 'es-toolkit';
import type { RootState } from '/business/shared/state/store';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

export default createDeepEqualSelector(
  (state: RootState) => state.basket?.meta?.electLocations,
  (heatSteamElectricityLocations?: ElectricityHeatSteamLocation[]) => {
    if (!heatSteamElectricityLocations) {
      return [];
    }
    return [...heatSteamElectricityLocations].sort((a, b) => (b.id || 0) - (a.id || 0));
  },
);
